export { getCommunicationsTableColumns } from './getCommunicationsTableColumns';
export { mapTabData } from './mapTabData';
export { prepareCommunicationsTableData } from './prepareCommunicationsTableData';
